import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';

import { ActionablePlaceholder } from 'ui-components/components/display-grid/actionable-placeholder';
import { noop } from 'ui-components/default-props/noop';

const messages = defineMessages({
  title: {
    description: 'Preset Groups Placeholder Title',
    defaultMessage: 'You have no {statusView} to view',
    id: 'QI7vmi',
  },
  description: {
    description: 'Preset Groups Placeholder Description',
    defaultMessage: 'No Preset Groups data to view at the moment',
    id: 'uAod1I',
  },
  boldStatusView: {
    description: 'Preset Groups Placeholder Bold Status View Name',
    defaultMessage: 'Preset Groups',
    id: 'vEWJx6',
  },
});

const PresetGroupsGridPlaceholder = () => {
  return (
    <ActionablePlaceholder
      action={noop}
      description={<FormattedMessage {...messages.description} />}
      title={
        <FormattedMessage
          {...messages.title}
          values={{
            statusView: (
              <b>
                <FormattedMessage {...messages.boldStatusView} />
              </b>
            ),
          }}
        />
      }
    />
  );
};

export default PresetGroupsGridPlaceholder;
